import React, { useState, useEffect } from "react";
import {
  getAllPartySearch,
  getAllGeneralLedger,
} from "../../api/endpoints/search";
import {
  getVoucher,
  saveData,
  getData,
  updateReceipt,
  deleteSingleReceipt,
  deleteReceipt,
  descReceipt,
  ascReceipt,
  onePreData,
  oneNextData,
} from "../../api/endpoints/receipts";
import { getAllBookings } from "../../api/endpoints/booking";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import SideBar from "../sidebar/sideBar";
import "./receipts.css";
import { authSelector } from "../../store/selectors/index";
import { Modal, message } from "antd";
import { Button, Dropdown, Select, Menu } from "antd";
import { useSelector } from "react-redux";
import { EMeters } from "../../enums/meters";
import Popup from "../modals/Popup";
import { getSiteRefrence } from "../../api/endpoints/refrences";

const { Option } = Select;

const Receipts = () => {
  const { user, access_token } = useSelector(authSelector);
  const [typeLast, setTypeLast] = useState("");
  const [voucher, setVoucher] = useState();
  const [voucherType] = useState("CV");
  const [transactionId, setTransactionId] = useState();
  const [type, setType] = useState("ADD");
  const [shift, setShift] = useState("");
  const [itemsQueue, setItemsQueue] = useState([]);
  const [editedItem, setEditedItem] = useState(null);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [total, setTotal] = useState();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [dateEntered, setDateEntered] = useState("");

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setDateEntered(today);
  }, []);

  // -------------------------- STATE ----------

  const [state, setState] = useState({
    parties: [],
    partyId: "", //ac no.
    bookingId: "",
    bookingName: "",
    partyName: "", // supplier name
    ledgerCodes: [],
    bookings: [],
    glCode: "",
    TDate: "",
    Shift: "",
    glDescription: "",
    description: "",
    invoiceNo: "",
    VNo: "",
    credit: "",
    id: "",
    PTrid: "",
    cheque: "",
    transactionIdInc: "",
  });

  const clearState = () => {
    setState({
      parties: state.parties,
      partyId: "",
      partyName: "",
      ledgerCodes: state.ledgerCodes,
      bookings: state.bookings,
      bookingId: "",
      bookingName: "",
      glCode: "",
      glDescription: "",
      TDate: "",
      Shift: "",
      description: "",
      invoiceNo: "",
      credit: "",
      cheque: "",
    });
  };

  const clearStates = () => {
    clearState();
    setTypeLast("");
    setEditedItem(null);
    setFieldsShow(false);
    setItemsQueue([]);
    setShift("");
    setDateEntered("");
    setVoucher("");
    setTotal(0);
    setType("ADD");
  };

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  // ------------------- ADD VOUCHER ---------------

  const addVoucher = async () => {
    if (!dateEntered) return message.error("Please type date !");
    const payload = {
      enteredOn: dateEntered,
    };
    const result = await getVoucher(payload, access_token);
    // const transactionId = await getTransactionId(access_token);
    if (result.success) {
      setVoucher(result.data);
      setType("SAVE");
      setFieldsShow(true);
    } else {
      message.error(result.message);
    }
    // if (transactionId.success) {
    //   setTransactionId(transactionId.data);
    // }
    // console.log(transactionId.data, "trannass");
  };
  // ------------------ SAVE DATA -----------------

  const [allowedShift, setAllowedShift] = useState();
  const getRefrences = async () => {
    const _refrences = await getSiteRefrence(access_token);
    setAllowedShift(_refrences.data.Shifts);
  };

  useEffect(() => {
    getRefrences();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async () => {
    // if (!shift) return message.error("Please type shift!");
    // if (shift > allowedShift)
    //   return message.error(`Your allowed shifts are ${allowedShift}`);
    if (itemsQueue.length === 0) return message.error("Add minimun 1 Entry");
    setIsButtonDisabled(true);

    const payload = itemsQueue.reduce((acc, curr, i) => {
      return [
        ...acc,
        {
          TDate: dateEntered,
          RDate: dateEntered,
          Shift: Number(shift),
          Pid: Number(curr.partyId),
          bookingId: Number(curr.bookingId),
          Descr: curr.description,
          InvNo: curr.invoiceNo,
          GLCode: curr.glCode,
          Credit: Number(curr.credit),
          CheqNo: curr.cheque,
          PTrId: i + 1,
          // transactionId: Number(curr.transactionIdInc),
          VNo: Number(voucher),
          VType: voucherType,
          siteId: Number(user.siteId),
          grpId: Number(user.grpId),
          // approved: user.authorized === true ? true : false,
        },
      ];
    }, []);
    try {
      const result = await saveData(payload, access_token);
      if (result.success) {
        clearStates();
        message.success(result.message || "Successfully entered!");
      } else {
        message.error(result.message || "Failed to save!");
      }
    } catch (error) {
      console.error("Error while saving:", error);
    } finally {
      setIsButtonDisabled(false); // Re-enable the button after the async operation completes

      // Enable the button again, whether the API call succeeds or fails
    }
  };

  // ---------------- ALL ITEMS ----------------

  const getAllData = async () => {
    const _parties = await getAllPartySearch(access_token);
    const _bookings = await getAllBookings(access_token);
    const _ledgerCodes = await getAllGeneralLedger(access_token);
    setState({
      ...state,
      parties: _parties,
      bookings: _bookings,
      ledgerCodes: _ledgerCodes,
    });
  };
  useEffect(() => {
    getAllData();
    if (itemsQueue.length === 0) return;
    let creditSum = itemsQueue.reduce(
      (arr, curr) => arr + Number(curr?.credit || 0),
      0
    );
    setTotal(Number(creditSum));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsQueue]);

  // ---------------------- ADD ITEM TO QUEUE --------------

  const addItem = () => {
    if (!state.credit || !state.glCode || !state.description) {
      return message.error(
        `Please type ${
          !state.credit
            ? "credit amount"
            : !state.glCode
              ? "GL CODE"
              : !state.description
                ? "Description"
                : ""
        }`
      );
    } else {
      state.transactionIdInc = transactionId + 1;
      setItemsQueue([...itemsQueue, state]);
      setTransactionId(state.transactionIdInc);
      clearState();

      const nextInput = inputRefs["accountName"];
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  // -------- EDIT ITEM

  const editItem = async () => {
    if (state.id) {
      await updateSingleApi();
    } else {
      itemsQueue[editedItem] = state;
      setItemsQueue([...itemsQueue]);
      setEditedItem(null);
      clearState();
    }
  };

  // -------- EDIT ITEM

  const deleteItem = (index) => {
    // const prevObject = itemsQueue[i]
    itemsQueue.splice(index, 1);
    setItemsQueue([...itemsQueue]);
    setEditedItem(null);
    console.log("deleteItem");
    clearState();
  };

  // ---------------------- EDIT API ------------------

  const [editPopup, setEditpopup] = useState(false);
  const edit = () => {
    setEditpopup(true);
  };

  const editHandler = async () => {
    if (!voucher) return message.error("Please type voucher number!");
    const results = await getData(voucher, access_token);
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.PtyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.PTrId,
            PTrId: curr.PTrId,
            dateEntered: curr.TDate,
            TDate: curr.TDate,
            Shift: curr.Shift,
            VNo: curr.VNo,
            partyId: Number(curr.Pid),
            bookingName: curr.CName,
            bookingId: Number(curr.bookingId),
            description: curr.Descr,
            invoiceNumber: curr.InvNo,
            glCode: Number(curr.GLCode),
            glDescription: curr.GLDescription,
            partyName: partyName,
            credit: Number(curr.Credit),
            cheque: curr.CheqNo,
            // transactionIdInc: Number(curr.transactionId),
            ledgerCodes: state.ledgerCodes,
            bookings: state.bookings,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].TDate);
      setVoucher(results.data[0].VNo);
      setShift(results.data[0].Shift);
      setEditpopup(false);
      setType("EDIT");
    } else {
      message.error(results.message);
    }
  };
  console.log(state, "stateee");

  // ---------------------- EDIT SINGLE API ------------------

  const updateSingleApi = async () => {
    const payload = {
      PTrId: state.id,
      Pid: Number(state.partyId),
      Descr: state.description,
      CheqNo: state.cheque,
      bookingId: Number(state.bookingId),
      Credit: Number(state.credit),
      InvNo: state.invoiceNo,
      GLCode: Number(state.glCode),
      TDate: state.TDate,
      Shift: state.Shift,
      Vno: voucher,
    };

    const response = await updateReceipt(payload, access_token);
    if (response.success) {
      await editHandler();
      message.success(response.message);
      clearState();
      setFieldsShow(false);
    } else {
      message.error(response.message);
    }
  };

  // ---------------- DELETE PURCHASE

  // -------- single

  const [modal, contextHolder] = Modal.useModal();
  const deleteSinglePurchase = async (id, TDate, VNo, Shift) => {
    const results = await deleteSingleReceipt(
      id,
      TDate,
      VNo,
      Shift,
      access_token
    );
    if (results.success) {
      if (itemsQueue.length !== 1) {
        await editHandler();
      } else {
        setItemsQueue([]);
      }
      message.success("Record Deleted Successfully !");
      // clearStates()
    } else {
      message.error(results.message);
    }
  };

  const confirmDelete = (id, TDate, VNo, Shift) => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Record?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deleteSinglePurchase(id, TDate, VNo, Shift),
    });
  };

  // -------- whole data

  const [deletePopup, setDeletepopup] = useState(false);
  const deletePurchase = () => {
    setDeletepopup(true);
  };

  const deletePurchaseHandler = async () => {
    const results = await deleteReceipt(voucher, access_token);
    if (results.success) {
      clearStates();
      message.success("Record Deleted Successfully !");
      clearStates();
      setDeletepopup(false);
    } else {
      message.error(results.message);
    }
  };
  const confirmDeleteAll = () => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Voucher?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deletePurchaseHandler(),
    });
  };

  //----------------order by desc----------------------
  const descVoucher = async () => {
    const results = await descReceipt(access_token);
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        // const partyName = curr.PtyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.TDate,
            shift: curr.Shift,
            partyId: Number(curr.Pid),
            description: curr.Description,
            invoiceNumber: curr.InvNo,
            glCode: Number(curr.GLCode),
            glDescription: curr.GLDescription,
            credit: Number(curr.Credit),
            cheque: curr.CheqNo,
            partyName: curr.CName,
            voucher: Number(curr.VNo),
            PTrid: Number(curr.PTrId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].TDate);
      setVoucher(results.data[0].VNo);
      setShift(results.data[0].Shift);
      setTypeLast(EMeters.LAST);
    } else {
      message.error(results.message);
    }
  };

  const ascVoucher = async () => {
    const results = await ascReceipt(access_token);
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.PtyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.TDate,
            shift: curr.Shift,
            partyId: Number(curr.Pid),
            description: curr.Description,
            invoiceNumber: curr.InvNo,
            glCode: Number(curr.GLCode),
            glDescription: curr.GLDescription,
            credit: Number(curr.Credit),
            cheque: curr.CheqNo,
            partyName: curr.CName,

            voucher: Number(curr.VNo),
            PTrid: Number(curr.PTrId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].TDate);
      setVoucher(results.data[0].VNo);
      setShift(results.data[0].Shift);
      setTypeLast(EMeters.LAST);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const onePreVoucher = async () => {
    let data = {
      voucherNumber: voucher,
    };
    const results = await onePreData(data, access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.party?.partyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.TDate,
            shift: curr.Shift,
            partyId: Number(curr.Pid),
            description: curr.Description,
            invoiceNumber: curr.InvNo,
            glCode: Number(curr.GLCode),
            glDescription: curr.GLDescription,
            credit: Number(curr.Credit),
            cheque: curr.CheqNo,
            partyName: curr.CName,

            voucher: Number(curr.VNo),
            PTrid: Number(curr.PTrId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].TDate);
      setVoucher(results.data[0].VNo);
      setShift(results.data[0].Shift);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const oneNextVoucher = async () => {
    let data = {
      voucherNumber: voucher,
    };
    const results = await oneNextData(data, access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.party?.partyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.TDate,
            shift: curr.Shift,
            partyId: Number(curr.Pid),
            description: curr.Description,
            invoiceNumber: curr.InvNo,
            glCode: Number(curr.GLCode),
            glDescription: curr.GLDescription,
            credit: Number(curr.Credit),
            cheque: curr.CheqNo,
            partyName: curr.CName,

            voucher: Number(curr.VNo),
            PTrid: Number(curr.PTrId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].TDate);
      setVoucher(results.data[0].VNo);
      setShift(results.data[0].Shift);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const menu = (index) => {
    return (
      <Menu>
        <Menu.Item key="0">
          <button
            onClick={() => {
              setFieldsShow(true);
              setEditedItem(index);
              setState(itemsQueue[index]);
              console.log(itemsQueue, "edit");
            }}
          >
            <AiFillEdit className="mr-2 mt-1" />

            <span>Edit</span>
          </button>
        </Menu.Item>
        {type === "SAVE" ? (
          <Menu.Item key="1">
            <button
              onClick={() => {
                deleteItem(index);
              }}
            >
              {" "}
              Delete
            </button>
          </Menu.Item>
        ) : (
          <Menu.Item key="1">
            <button
              onClick={() => {
                confirmDelete(
                  itemsQueue[index].id,
                  itemsQueue[index].VNo,
                  itemsQueue[index].TDate,
                  itemsQueue[index].Shift
                );
              }}
            >
              {" "}
              Delete
            </button>
          </Menu.Item>
        )}
      </Menu>
    );
  };

  const inputRefs = {};
  const addInputFieldRef = (ref, fieldName) => {
    if (ref && fieldName) {
      inputRefs[fieldName] = ref;
    }
  };
  const handleEnterKey = (e, fieldName) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior of the "Enter" key

      // Trigger addItem function if the current field is "amount"
      if (fieldName === "credit") {
        Boolean(editedItem != null) ? editItem() : addItem();
      } else {
        const currentFieldName = fieldName;

        // Define the order of input fields
        const fieldOrder = [
          "dateEntered",
          "accountName",
          "glCode",
          "description",
          "invoiceNo",
          "cheque",
          "credit",
          // Add more field names as needed
        ];

        // Find the index of the current field in the order array
        const currentIndex = fieldOrder.indexOf(currentFieldName);
        console.log(currentIndex, "current Inddd");
        if (currentIndex !== -1 && currentIndex < fieldOrder.length - 1) {
          // Move focus to the next input field
          const nextFieldName = fieldOrder[currentIndex + 1];
          const nextInput = inputRefs[nextFieldName];

          if (nextInput) {
            nextInput.focus();
          }
        }
      }
    }
  };

  return (
    <div className="flex  bg-black recive-main">
      <SideBar />
      <div className="h-full  flex flex-col content-center  w-full">
        <div className="meterTableMain ml-10 mt-6o mr-10">
          {contextHolder}
          <div className="bg-blue-500 headingBox flex justify-between">
            <h3 className=" text-white tableHeading pl-10">
              CASH RECEIPT ENTRY
            </h3>
          </div>
          <div className="bg-blue-500">
            <div
              className="flex content-center  ml-10 pb-3"
              style={{
                display: "flow-root",
              }}
            >
              <input
                readOnly
                value={voucher}
                className="inpTxt inpTxtVoucher p-2 h-9  mb-3 w-40"
              />
              <input
                type="date"
                value={dateEntered}
                className="text-black inpTxt p-2 h-9 ml-3 mb-3 w-40"
                onChange={(e) => setDateEntered(e.target.value)}
                onKeyDown={(e) => handleEnterKey(e, "dateEntered")}
                ref={(ref) => addInputFieldRef(ref, "dateEntered")}
              />

              {fieldsShow && (
                <>
                  <Select
                    showSearch
                    className=" bg-white  inpTxtVoucher text-white ml-3 mt-5 inpTxt  p-1 h-9  w-52"
                    placeholder="Name"
                    optionFilterProp="children"
                    value={state.partyName || "Name"}
                    onChange={(e) => {
                      const { PtyName, GlCode, Description } =
                        state.parties.find((el) => el.PID === e);
                      setState({
                        ...state,
                        partyId: e,
                        partyName: PtyName,
                        glCode: GlCode,
                        glDescription: Description,
                      });
                    }}
                  >
                    {state.parties.map((el) => (
                      <Option value={el.PID}>{el.PtyName}</Option>
                    ))}
                  </Select>

                  <Select
                    showSearch
                    className="ant-select ant-select ant-select border-0 bg-white text-white ml-3 mt-5 inpTxt  p-1 h-9  w-52"
                    placeholder="GL Description"
                    optionFilterProp="children"
                    value={state.glDescription || "GL Description "}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.CODE === e
                      );
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.Description,
                      });
                    }}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option value={el.CODE}>{el.Description}</Option>
                    ))}
                  </Select>
                </>
              )}
            </div>
          </div>
          {fieldsShow && (
            <div className="">
              <div className="flex content-center flex-wrap mb-1 ml-10">
                <div className="">
                  <Select
                    showSearch
                    placeholder="Booking"
                    name="accountNumber"
                    className="ant-select  bg-black text-white  inpTxt mt-5 p-1 h-9  w-52"
                    optionFilterProp="children"
                    value={state.bookingId || "Booking"}
                    onChange={(e) => {
                      const _party = state.bookings.find(
                        (el) => el.BookingID === e
                      );
                      if (_party) {
                        setState({
                          ...state,
                          bookingId: e,
                          bookingName: _party.CName,
                          glCode: _party.GLCode,
                        });
                      } else {
                        setState({
                          ...state,
                          bookingId: e,
                          // partyName: "",
                        });
                      }
                    }}
                    onKeyDown={(e) => handleEnterKey(e, "accountName")}
                    ref={(ref) => addInputFieldRef(ref, "accountName")}
                  >
                    <Option value={0}>None</Option>
                    {state.bookings.map((el) => (
                      <Option
                        value={el.BookingID}
                      >{`${el.BookingID} - ${el.CName}`}</Option>
                    ))}
                  </Select>
                </div>
                <div className="">
                  <Select
                    showSearch
                    name="partyId"
                    // disabled={Boolean(state.glCode)}
                    className="ant-select ant-select bg-black text-white ml-3 mt-5 inpTxt  p-1 h-9  w-64"
                    placeholder=""
                    optionFilterProp="children"
                    value={state.partyId || "Party Id"}
                    onChange={(e) => {
                      const lCode = state.parties.find((el) => el.PID === e);

                      setState({
                        ...state,
                        partyId: e,
                        partyName: lCode.PtyName,
                        glCode: lCode.GLCode,
                        glDescription: lCode.Description,
                      });
                    }}
                    onKeyDown={(e) => handleEnterKey(e, "glCode")}
                    ref={(ref) => addInputFieldRef(ref, "glCode")}
                  >
                    {state.parties.map((el) => (
                      <Option value={el.PID}>
                        {`${el.PID} - ${el.PtyName}`}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="">
                  <Select
                    showSearch
                    name="glcode"
                    className="ant-select ant-select bg-black text-white ml-3 mt-5 inpTxt  p-1 h-9  w-64"
                    placeholder="Credit GL Code"
                    optionFilterProp="children"
                    value={state.glCode || "Credit GL Code"}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.CODE === e
                      );
                      console.log(lCode, "lcode");
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.Description,
                      });
                    }}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option value={el.CODE}>
                        {`${el.CODE} - ${el.Description}`}
                      </Option>
                    ))}
                  </Select>
                </div>
                <input
                  type="text"
                  name="description"
                  value={state.description}
                  onChange={onChangeText}
                  placeholder="Description"
                  className=" ant-select bg-black text-white  mt-5 inpTxt pt-3  p-1 h-9 ml-3 w-52"
                  onKeyDown={(e) => handleEnterKey(e, "description")}
                  ref={(ref) => addInputFieldRef(ref, "description")}
                />
                <input
                  type="text"
                  name="invoiceNo"
                  value={state.invoiceNo}
                  onChange={onChangeText}
                  placeholder="Invoice No"
                  className="ant-select bg-black text-white  mt-5 inpTxt pt-3 p-1 h-9 ml-3 w-28"
                  onKeyDown={(e) => handleEnterKey(e, "invoiceNo")}
                  ref={(ref) => addInputFieldRef(ref, "invoiceNo")}
                />
                <input
                  type="text"
                  name="cheque"
                  value={state.cheque}
                  onChange={onChangeText}
                  placeholder="Chq/DD"
                  className="ant-select bg-black text-white mt-5  inpTxt pt-3 p-1 h-9 ml-3 w-24"
                  onKeyDown={(e) => handleEnterKey(e, "cheque")}
                  ref={(ref) => addInputFieldRef(ref, "cheque")}
                />

                <input
                  type="number"
                  name="credit"
                  value={state.credit}
                  onChange={onChangeText}
                  placeholder="Credit"
                  onKeyDown={(e) => handleEnterKey(e, "credit")}
                  ref={(ref) => addInputFieldRef(ref, "credit")}
                  className="ant-select bg-black text-white  mt-5 inpTxt pt-3 p-1 h-9 ml-3 w-28"
                />
                {Boolean(editedItem != null) ? (
                  <button
                    onClick={editItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white  mt-5 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillEdit className="mr-2 mt-1" />
                    <span>Edit</span>
                  </button>
                ) : (
                  <button
                    onClick={addItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-5  p-1 h-9 ml-3 w-20 rounded"
                  >
                    <span> + Add</span>
                  </button>
                )}
              </div>
            </div>
          )}

          <div className="div">
            <div className="flex">
              <div
                className=" shadow-md sm:rounded-lg tableDiv p-5 pl-10  w-full"
                style={{ overflow: "auto", maxHeight: "350px" }}
              >
                <table className=" w-full text-sm  text-left text-gray-500 dark:text-gray-400">
                  <thead className="bg-blue-500  text-white uppercase dark:bg-gray-700 tableHeading  dark:text-gray-400">
                    <tr>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        SNo.
                      </th>
                      {/* <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        GL CODE
                      </th>*/}
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Party Name
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Booking ID
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Booking Name
                      </th>

                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        DESCRIPTION
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Invoice
                      </th>

                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Cheque/DD
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Credit
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        ACTION
                      </th>
                    </tr>
                  </thead>
                  <tbody className="tableBody">
                    {itemsQueue.map((ele, i) => {
                      return (
                        <tr key={i} className="tbodyData text-white">
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            {i + 1}
                          </td>
                          {/* <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.glCode}</p>
                          </td>{" "}*/}
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.partyName}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.bookingId}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.bookingName}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.description}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.invoiceNo}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.cheque}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.credit}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <Dropdown overlay={menu(i)} placement="bottomLeft">
                              <Button>Action</Button>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="pr-5 flex justify-end">
            <input
              type="text"
              readOnly
              placeholder=""
              name=""
              id=""
              value={total}
              className="mt-2 pl-3 pt-1 pb-1 w-32 bg-black text-white outline-none"
            />
          </div>
          <div className="pl-9 pb-2 flex justify-between">
            <div className="flex">
              {type === "ADD" && (
                <button
                  onClick={addVoucher}
                  className="bg-blue-500 hover:bg-blue-700 h-9 flex text-white mt-3 py-1 px-4 rounded"
                >
                  <AiFillFileAdd className="mr-2 mt-1" />

                  <span>Add</span>
                </button>
              )}

              {type === "SAVE" && (
                <button
                  onClick={save}
                  className={`bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 py-1 px-4 rounded ${
                    isButtonDisabled ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  disabled={isButtonDisabled}
                >
                  <AiFillSave className="mt-1 mr-2 " />
                  <span>Save</span>
                </button>
              )}

              {type === "ADD" && (
                <button
                  onClick={edit}
                  className="bg-blue-500 hover:bg-blue-700 h-9 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                >
                  <AiFillEdit className="mr-2 mt-1" />

                  <span>Edit</span>
                </button>
              )}

              <button
                onClick={() => deletePurchase()}
                className="bg-blue-500 hover:bg-blue-700 h-9 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                disabled={type !== "ADD"}
              >
                <AiFillDelete className="mr-2 mt-1" />

                <span>Delete</span>
              </button>
              <button
                onClick={() => {
                  clearStates();
                }}
                className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 h-9 ml-3 py-1 px-4 rounded"
              >
                <BiExit className="mr-2 mt-1" />
                {type === "EDIT" ? "Done" : "Exit"}
              </button>
            </div>
            <div className="flex content-end mt-3 bg-white justify-end"></div>

            <div className="pr-5">
              <button
                onClick={ascVoucher}
                className="bg-blue-500 hover:bg-blue-700 text-white mt-3 py-1 px-4 rounded"
              >
                <img src={`./img/first.png`} alt="" />
              </button>
              {typeLast === "LAST" && (
                <button
                  onClick={onePreVoucher}
                  className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                >
                  <img src={`./img/previous.png`} alt="" />
                </button>
              )}
              {typeLast === "LAST" && (
                <button
                  onClick={oneNextVoucher}
                  className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                >
                  <img src={`./img/next.png`} alt="" />
                </button>
              )}
              <button
                onClick={descVoucher}
                className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
              >
                <img src={`./img/latest.png`} alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Popup popup={editPopup} handlePopup={setEditpopup} onOk={editHandler}>
        <div>
          <h2>Please type voucher number</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      </Popup>

      <Popup
        popup={deletePopup}
        handlePopup={setDeletepopup}
        onOk={confirmDeleteAll}
      >
        <div>
          <h2>Please type voucher number for delete record</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      </Popup>
    </div>
  );
};

export default Receipts;
